
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface AdditionalInfoProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (value: string, name: string) => void;
}

export const AdditionalInfoSection = ({ formData, handleInputChange, handleSelectChange }: AdditionalInfoProps) => {
  const ageOptions = [
    "<18 years",
    "18-23 years",
    "24-28 years",
    "29-35 years",
    "36-45 years",
    "45-55 years",
    "56-65 years",
    ">65 years"
  ];

  const referralOptions = [
    "University",
    "Friend/Family",
    "Flyer",
    "Google",
    "Other"
  ];

  return (
    <div className="border border-[#E5E7EB] rounded-lg p-6 space-y-4">
      <h3 className="font-semibold text-[#1F2937] flex items-center gap-2">
        <span className="text-[#6B7280]">📝</span>
        Additional Information
      </h3>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="age">Your Age</Label>
          <Select
            name="age"
            value={formData.age}
            onValueChange={(value) => handleSelectChange(value, 'age')}
          >
            <SelectTrigger id="age" className="w-full text-muted-foreground">
              <SelectValue placeholder="Your Age" />
            </SelectTrigger>
            <SelectContent>
              {ageOptions.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="referralSource">How did you hear about us?</Label>
          <Select
            name="referralSource"
            value={formData.referralSource}
            onValueChange={(value) => handleSelectChange(value, 'referralSource')}
          >
            <SelectTrigger id="referralSource" className="w-full text-muted-foreground">
              <SelectValue placeholder="Select an option" />
            </SelectTrigger>
            <SelectContent>
              {referralOptions.map((option) => (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="additionalComments">Additional Information</Label>
          <Textarea
            id="additionalComments"
            placeholder="What information are you most interested in seeing? (optional)"
            name="additionalComments"
            value={formData.additionalComments}
            onChange={handleInputChange}
            className="h-24"
          />
        </div>
      </div>
    </div>
  );
};

